import { render } from "./FilterWilayahSemuaMultiple.vue?vue&type=template&id=a81d7ada"
import script from "./FilterWilayahSemuaMultiple.vue?vue&type=script&lang=js"
export * from "./FilterWilayahSemuaMultiple.vue?vue&type=script&lang=js"
script.render = render

export default script